import { gql } from '@apollo/client'

export default gql(`
    query{
        listMasterFields{
            id
            displayName
            fieldName
            fields{
              name
              displayName
              type
              isRequired
            }
          }
}`)
